import isString from 'lodash/isString.js';

/**
 * Check id a string contains HTML tags
 * @param string {string} : 'This is some text with some <b>HTML</b>'
 * @returns {boolean}
 */

function checkHTML(string = '') {
  if (!isString(string)) {
    return false;
  }

  return string.match(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi) !== null;
}

export default checkHTML;
